import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'dd-tgpp-file-upload',
    templateUrl: './tgpp-file-upload.component.html',
    styleUrls: ['./tgpp-file-upload.component.scss'],
    standalone: false
})
export class TgppFileUploadComponent {
  @Input() filTypes = '.pdf,.doc, .xlsx';
  @Input() buttonType = '';
  @Output() inputChange: EventEmitter<any> = new EventEmitter<any>();

  onFileChange(event) {
    this.inputChange.emit(event);
  }

}
